import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { InvestorProfile, ResetPassword } from '@/pages';
import { DocumentRequest, ProfileDocuments } from '@/containers';
import { Product, Questionnaire, SumsubQuestionnaire } from '@/modules';
import { ReferralProfileView } from '@/pages/investor/ReferralProfile';
import { InvestorLayout } from '@/layouts';
import { ProfileInfo, ProfileProducts, ProfileReferrals, ProfileStatus } from '@/components';

export const InvestorRoutes = () => {
  return (
    <Routes>
      <Route element={<InvestorLayout />}>
        <Route path='profile'>
          <Route element={<InvestorProfile />}>
            <Route index element={<ProfileInfo />} />

            <Route path='questionnaires' element={<ProfileStatus />} />

            <Route path='documents' element={<ProfileDocuments />} />

            <Route path='referrals' element={<ProfileReferrals />} />

            <Route path='products' element={<ProfileProducts />} />
          </Route>
        </Route>
      </Route>

      <Route path='questionnaire'>
        <Route path=':id' element={<Questionnaire />} />
      </Route>

      <Route path='product'>
        <Route path=':id' element={<Product />} />
      </Route>

      <Route path='sumsub-verification' element={<SumsubQuestionnaire />} />

      <Route path='documents'>
        <Route path=':id' element={<DocumentRequest />} />
      </Route>

      <Route element={<InvestorLayout referralView />}>
        <Route path='referral'>
          <Route path=':id' element={<ReferralProfileView />}>
            <Route path='questionnaires' element={<ProfileStatus referralView />} />

            <Route path='documents' element={<ProfileDocuments referralView />} />

            <Route path='products' element={<ProfileProducts referralView />} />
          </Route>
        </Route>
      </Route>

      <Route path='referral'>
        <Route path=':referralId'>
          <Route path='questionnaire'>
            <Route path=':id' element={<Questionnaire referralView />} />
          </Route>
          <Route path='product'>
            <Route path=':id' element={<Product referralView />} />
          </Route>
          <Route path='documents'>
            <Route path=':id' element={<DocumentRequest referralView />} />
          </Route>
        </Route>
      </Route>

      <Route path='change-password' element={<ResetPassword />} />

      {/* Fallback route */}
      <Route path='*' element={<Navigate to='/profile' replace />} />
    </Routes>
  );
};
